import { MainLayout } from "@/components/layouts/main-layout";
import { Outlet, createFileRoute } from "@tanstack/react-router";

import { SettingsLayout as _SettingsLayout } from "@/components/layouts/settings-layout";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_settings",
)({
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <MainLayout>
      <_SettingsLayout>
        <Outlet />
      </_SettingsLayout>
    </MainLayout>
  );
}
